import { Routes, Route, Navigate } from "react-router-dom";
import { ProtectedRoute } from "./routes/ProtectedRoute";
import { RoleRoute } from "./routes/RoleRoute";
import { AppShell } from "./components/layout/AppShell";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Tickets from "./pages/Tickets";
import TicketDetail from "./pages/TicketDetail";
import CreateTicket from "./pages/CreateTicket";
import Management from "./pages/Management";
import IssueSystemTracker from "./pages/IssueSystemTracker";
import IssueHardwareTracker from "./pages/IssueHardwareTracker";
import IssueSoftwareTracker from "./pages/IssueSoftwareTracker";
import IssueNetworkTracker from "./pages/IssueNetworkTracker";
import IssueAccessTracker from "./pages/IssueAccessTracker";
import History from "./pages/History";
import RecycleBin from "./pages/RecycleBin";
import NotFound from "./pages/NotFound";
import DepartmentTickets from "./pages/DepartmentTickets";
import Announcements from "./pages/Announcements";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/tickets" element={<Tickets />} />
        <Route path="/tickets/new" element={<CreateTicket />} />
        <Route path="/tickets/:id" element={<TicketDetail />} />
        <Route
          path="/department-tickets"
          element={
            <RoleRoute roles={["AGENT"]}>
              <DepartmentTickets />
            </RoleRoute>
          }
        />
        <Route path="/announcements" element={<Announcements />} />
        <Route path="/history" element={<History />} />
        <Route
          path="/recycle-bin"
          element={
            <RoleRoute roles={["IT", "ADMIN"]}>
              <RecycleBin />
            </RoleRoute>
          }
        />
        <Route
          path="/system-tracker"
          element={
            <RoleRoute roles={["IT", "ADMIN"]}>
              <IssueSystemTracker />
            </RoleRoute>
          }
        />
        <Route
          path="/hardware-tracker"
          element={
            <RoleRoute roles={["IT", "ADMIN"]}>
              <IssueHardwareTracker />
            </RoleRoute>
          }
        />
        <Route
          path="/software-tracker"
          element={
            <RoleRoute roles={["IT", "ADMIN"]}>
              <IssueSoftwareTracker />
            </RoleRoute>
          }
        />
        <Route
          path="/network-tracker"
          element={
            <RoleRoute roles={["IT", "ADMIN"]}>
              <IssueNetworkTracker />
            </RoleRoute>
          }
        />
        <Route
          path="/access-tracker"
          element={
            <RoleRoute roles={["IT", "ADMIN"]}>
              <IssueAccessTracker />
            </RoleRoute>
          }
        />
        <Route
          path="/management"
          element={
            <RoleRoute roles={["ADMIN"]}>
              <Management />
            </RoleRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default App;
